<template>
  <nav class="bottom-nav" aria-label="Navigation principale">
    <div class="bottom-nav-container">
      <router-link
        v-for="(item, index) in menuItems"
        :key="index"
        :to="item.route"
        class="bottom-nav-item"
        active-class="active"
        exact-active-class="active"
      >
        <div class="bottom-nav-icon">
          <i :class="item.icon"></i>
        </div>
        <span class="bottom-nav-label">{{ item.title }}</span>
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: "BottomNavigation",
  data() {
    return {
      menuItems: [
        {
          title: "Accueil",
          icon: "bi bi-house",
          route: { name: "home" },
        },
        // {
        //   title: "Clients",
        //   icon: "bi bi-people",
        //   route: { name: "customers-list" },
        // },
        // {
        //   title: "Commandes",
        //   icon: "bi bi-receipt-cutoff",
        //   route: { name: "orders-list" },
        // },
        // {
        //   title: "Paiements",
        //   icon: "bi bi-credit-card",
        //   route: { name: "payments-list" },
        // },
      ],
    };
  },
};
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(18px);
  border-top: 1px solid rgba(15, 23, 42, 0.12);
  box-shadow: 0 -12px 32px rgba(15, 23, 42, 0.12);
  padding-bottom: max(env(safe-area-inset-bottom), 8px);
}

/* Hide on desktop */
@media (min-width: 768px) {
  .bottom-nav {
    display: none;
  }
}

.bottom-nav-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(68px, 1fr));
  align-items: center;
  gap: 0rem;
  padding: 0.25rem 0.35rem;
}

.bottom-nav-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  padding: 0.4rem 0.5rem;
  border-radius: 12px;
  text-decoration: none;
  color: var(--text-secondary, #64748b);
  font-size: 0.72rem;
  font-weight: 600;
  min-height: 40px;
  position: relative;
  overflow: hidden;
  transition: transform 0.2s ease, color 0.2s ease, background 0.2s ease,
    box-shadow 0.2s ease;
}

.bottom-nav-item::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle at top,
    rgba(79, 70, 229, 0.18),
    transparent 65%
  );
  opacity: 0;
  transition: opacity 0.25s ease;
  pointer-events: none;
}

.bottom-nav-item:hover {
  color: var(--primary-color, #4f46e5);
  transform: translateY(-2px);
}

.bottom-nav-item:hover::before {
  opacity: 1;
}

.bottom-nav-item.active {
  color: var(--primary-color, #4f46e5);
  background: rgba(79, 70, 229, 0.08);
  box-shadow: 0 14px 32px rgba(79, 70, 229, 0.18);
}

.bottom-nav-item.active::before {
  opacity: 1;
}

.bottom-nav-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: rgba(15, 23, 42, 0.06);
  transition: inherit;
}

.bottom-nav-icon i {
  font-size: 1.1rem;
  transition: inherit;
}

.bottom-nav-item.active .bottom-nav-icon {
  background: linear-gradient(
    145deg,
    var(--primary-color, #4f46e5),
    var(--primary-dark, #312e81)
  );
  transform: translateY(-4px) scale(1.06);
  color: #fff;
}

.bottom-nav-item.active .bottom-nav-icon i {
  color: #fff;
}

.bottom-nav-label {
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  letter-spacing: 0.01em;
  line-height: 1.2;
}

body.has-bottom-nav {
  padding-bottom: 72px;
}

@media (max-width: 768px) {
  .bottom-nav {
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
  }

  .bottom-nav-container {
    padding: 0.3rem 0.7rem 0.3rem;
    gap: 0.2rem;
  }

  .bottom-nav-item {
    min-height: 50px;
    padding: 0.35rem 0.4rem;
    gap: 0.2rem;
  }

  .bottom-nav-icon {
    width: 34px;
    height: 34px;
  }

  .bottom-nav-icon i {
    font-size: 1rem;
  }

  .bottom-nav-label {
    font-size: 0.65rem;
  }
}

@media (max-width: 480px) {
  .bottom-nav-item {
    gap: 0.15rem;
    min-height: 46px;
    padding: 0.3rem 0.35rem;
  }

  .bottom-nav-label {
    font-size: 0.62rem;
  }

  .bottom-nav-icon {
    width: 32px;
    height: 32px;
  }

  .bottom-nav-icon i {
    font-size: 0.95rem;
  }
}

@media (max-width: 360px) {
  .bottom-nav-label {
    display: none;
  }

  .bottom-nav-item {
    min-height: 42px;
    padding: 0.25rem 0.3rem;
  }

  .bottom-nav-icon {
    width: 30px;
    height: 30px;
  }

  .bottom-nav-icon i {
    font-size: 0.9rem;
  }
}
</style>
